<div class="container">


  <div *ngIf="isLoaded" style="text-align: center;">
    <button class="btn" (click)="prevPage()" [disabled]="page === 1">Prev</button>
    <span style="padding:0 20px; color:white;">{{ page }} / {{ totalPages }}</span>
    <button class="btn" (click)="nextPage()" [disabled]="page === totalPages">Next</button>
  </div>

  <div style="width: 100%; text-align: center;">
    <a href="./assets/pdfs/epk.pdf" download><span class="btn">Download EPK</span></a>
  </div>

  <br />
<!-- <div class="soon">Coming soon!</div> -->

  <pdf-viewer src="./assets/pdfs/epk.pdf"
  [show-all]="false"
  [page]="page"
  [fit-to-page]="true"
  (after-load-complete)="afterLoadComplete($event)">
  </pdf-viewer>

</div>
